const mEditionMapEnrollmentsFamiliesModalEdit = {
  mEditionMapEnrollmentsFamiliesModalEdit: {
    alerts: {
      updateFamilia: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El equipo fue editado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'GUARDAR',

    inputs: {
      nombre: {
        label: 'Nombre de Equipo',
        placeholder: ''
      }
    },

    title: 'Editar Equipo',

    validation: {
      nombre: {
        maxLength: 'La longitud máxima permitida es de 60 caracteres.',
        minLength: 'La longitud mínima permitida es de 1 caracteres.',
        required: 'Nombre de equipo es requerido.'
      }
    }
  }
}

export default mEditionMapEnrollmentsFamiliesModalEdit
